'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toSearchUrl = exports.toFacetUrlParams = exports.toFacetString = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _compact = require('lodash/compact');

var _compact2 = _interopRequireDefault(_compact);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* SELECTORS */
var toFacetLabel = function toFacetLabel(facet, value) {
    var selectionType = facet.selection;
    if (selectionType === 'single') {
        return value.name;
    }
    if (selectionType === 'single2') {
        return value.name;
    }
    if (selectionType === 'distance') {
        return facet.name + ': ' + facet.selected_postal_code;
    }
    if (selectionType === 'range') {
        return facet.name + ': ' + facet.selected_start + ' - ' + facet.selected_end; // add in currency
    }
    if (selectionType === 'multiple') {
        return value.name;
    }
    if (selectionType === 'keyword') {
        return facet.selected_value;
    }
    if (selectionType === 'date') {
        return facet.name;
    }
};

var toFacetString = exports.toFacetString = function toFacetString(facets) {
    var selections = [];
    facets.forEach(function (facet) {
        if (facet.qs === 'keyword') {
            selections.unshift(toFacetLabel(facet));
        } else if (facet.values) {
            facet.values.forEach(function (value) {
                selections.push(toFacetLabel(facet, value));
            });
        } else {
            selections.push(toFacetLabel(facet));
        }
    });
    return (0, _compact2.default)(selections).join(', ');
};

var toFacetUrlParam = function toFacetUrlParam(facet, oldValue) {
    var selectionType = facet.qs;
    if (facet.selection === 'single' || facet.selection === 'multiple') {
        var oldValues = oldValue ? oldValue.split(',') : [];
        var newValues = facet.values.map(function (x) {
            return '' + x.value;
        });
        return (0, _union2.default)(oldValues, newValues).join(',');
    }
    if (selectionType === 'keyword') {
        return facet.selected_value; // overwrite old value
    }
    if (facet.selection === 'range') {
        var _oldValues = oldValue ? oldValue.split(',') : [];

        var currency = facet.currencies.length ? facet.currencies[0].code : 'USD';
        var min = facet.selected_start;
        var max = facet.selected_end;
        var minValue = min !== '' && min !== undefined ? min : -1;
        var maxValue = max !== '' && max !== undefined ? max : -1;
        var newValue = currency + ':' + minValue + ':' + maxValue;

        return (0, _union2.default)(_oldValues, [newValue]).join(',');
    }
    if (facet.selection === 'distance') {
        var _oldValues2 = oldValue ? oldValue.split(',') : [];

        var country = facet.selected_country;
        var zipCode = facet.selected_postal_code;
        var range = facet.selected_radius;
        var measurement = facet.selected_radius_unit;
        var _newValue = country + ':' + zipCode + ':' + range + ':' + measurement;

        return (0, _union2.default)(_oldValues2, [_newValue]).join(',');
    }
};

var toFacetUrlParams = exports.toFacetUrlParams = function toFacetUrlParams(facets) {
    var url = {
        // published_date: null,
        // sort: '-publish_date',
    };
    facets.forEach(function (facet) {
        url[facet.qs] = toFacetUrlParam(facet, url[facet.qs]);
    });
    return (0, _stringify2.default)(url);
};

var toSearchUrl = exports.toSearchUrl = function toSearchUrl(facets) {
    var urlParams = toFacetUrlParams(facets);
    return '/search?parameters=' + encodeURIComponent(urlParams);
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/savedSearchFacets.js
// module id = y7cp
// module chunks = 57